import { BrainCircuit } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import { useEmoviDoc } from './hooks/useEmoviDoc';

type EmoviDocToggleButtonProps = {
  className?: string;
};

export function EmoviDocToggleButton({ className }: EmoviDocToggleButtonProps) {
  const { isOpen, setOpen } = useEmoviDoc();

  return (
    <Button
      variant="outline"
      size="sm"
      type="button"
      onClick={() => setOpen(!isOpen)}
      aria-pressed={isOpen}
      className={cn(
        isOpen && 'border-primary bg-primary/10 text-foreground hover:bg-primary/15',
        className,
      )}
    >
      <BrainCircuit className="h-4 w-4" aria-hidden />
      EmoviDoc
    </Button>
  );
}
